import React from 'react';
import {Provider} from 'react-redux';
import ReactDOM from 'react-dom';
import {Router} from 'react-router-dom';
import {createBrowserHistory} from 'history';
import {createPreserveQueryHistory, ScrollToTop} from './utils/routerUtils';
import MatchcenterApp from './MatchcenterApp';
import store from './store';

// TODO: remove all eslint exceptions from all files
// TODO: maybe consolidate all SVGs to single SVG sprite
// TODO: stylelint only @import scss files without output (to avoid duplicate css exporting)

const history = createPreserveQueryHistory(createBrowserHistory, ['sport24app'])({
  basename: process.env.PUBLIC_URL,
});

/**
 * The application root.
 */
const Index = () => (
  <Provider store={store}>
    <Router history={history}>
      <ScrollToTop />
      <MatchcenterApp />
    </Router>
  </Provider>
);

ReactDOM.render(<Index />, document.getElementById('root'));
